module.exports = __webpack_public_path__ + "assets/img/func5.779f772b.png";